// | ------------------------------------------------------------------------
// | Carousels
// | ------------------------------------------------------------------------

//? https://splidejs.com/
import Splide from "@splidejs/splide";

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  
  /*

  var hero = document.querySelector(".hero-image-carousel");
  var btnNext = document.querySelector(".hero-btn-next");
  var btnPrev = document.querySelector(".hero-btn-prev");

  if (hero) {
    var heroText = new Splide(".hero-text-carousel", {
      type: "loop",
      perPage: 1,
      perMove: 1,
      isNavigation: false,
      arrows: false,
      pagination: false,
      autoplay: true,
      pauseOnHover: true,
    }).mount();

    var heroImages = new Splide(".hero-image-carousel", {
      type: "fade",
      pagination: false,
      arrows: false,
      //cover: true,
      lazyLoad: "nearby",
    });

    var heroProds = new Splide(".hero-product-carousel", {
      type: "fade",
      pagination: false,
      arrows: false,
      cover: true,
    });

    heroImages.sync(heroText);
    heroImages.sync(heroProds);
    heroImages.mount();
    heroProds.mount();

    btnNext.addEventListener("click", (e) => {
      heroText.go("+1");
    });

    btnPrev.addEventListener("click", (e) => {
      heroText.go("-1");
    });
  }

  */

  var homeNews = document.querySelector(".home-news-carousel");

  if (homeNews) {
    var homeNewsCarousel = new Splide(".home-news-carousel", {
      type: "loop",
      pagination: true,
      arrows: true,
    });

    homeNewsCarousel.mount();
  }

  var logoCarousel = document.querySelector(".logo-carousel");

  if (logoCarousel) {
    var logos = new Splide(".logo-carousel", {
      type: "loop",
      perPage: 4,
      pagination: false,
      gap: "var(--global-spacing)",
      arrows: true,
      breakpoints: {
        576: {
          perPage: 1,
          arrows: true,
        },
        768: {
          perPage: 2,
          arrows: true,
        },
        992: {
          perPage: 3,
        },
      },
    });

    logos.mount();
  }

  var surveillanceCarousel = document.querySelector(".surveillance-carousel");

  if (surveillanceCarousel) {
    var surveillance = new Splide(".surveillance-carousel", {
      type: "loop",
      perPage: 3,
      pagination: false,
      gap: "var(--global-spacing)",
      arrows: true,
      breakpoints: {
        576: {
          perPage: 1,
          arrows: true,
        },
        768: {
          perPage: 2,
          arrows: true,
        },
        992: {
          perPage: 3,
        },
      },
    });

    surveillance.mount();
  }

  var successCarousel = document.querySelector(".success-carousel");

  if (successCarousel) {
    var success = new Splide(".success-carousel", {
      type: "loop",
      perPage: 3,
      pagination: false,
      arrows: false,
      breakpoints: {
        1400: {
          perPage: 2,
          arrows: true,
        },
        768: {
          perPage: 1,
          arrows: true,
        },
      },
    });

    success.mount();
  }

  var featuredCarousel = document.querySelector(".featured-carousel");

  if (featuredCarousel) {
    var featured = new Splide(".featured-carousel", {
      type: "loop",
      perPage: 2,
      pagination: false,
      arrows: true,
      gap: "var(--global-spacing)",
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    });

    featured.mount();
  }
});
